import MicroAppElement from './micro_app_element'
import { formatLogMessage } from './libs/utils'
export { default as preFetch } from './prefetch'
export { default } from './micro_app'
export { removeDomScope, pureCreateElement } from './libs/utils'

try {
  if (customElements && !customElements.get('micro-app')) {
    customElements.define('micro-app', MicroAppElement)
  }
} catch (ex) {
  console.error(
    formatLogMessage('customelements does not exist in the current environment'),
    ex
  )
}
